
export const formatName = (name: string) => {
    if (name?.length > 12) {
      return `${name?.substring(0, 12)}..`;
    }
    return name;
  };